var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconShareClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 9.5,
    fill: "url(#paint0_linear_1031_8429)",
    stroke: "#FFB829"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 9.6L22.4 8L16 14.4L9.6 8L8 9.6L14.4 16L8 22.4L9.6 24L16 17.6L22.4 24L24 22.4L17.6 16L24 9.6Z",
    fill: "#FFB829"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1031_8429",
    x1: 16,
    y1: 32,
    x2: 16,
    y2: -1.64916e-7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212224"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShareClose);
export default __webpack_public_path__ + "static/media/icon_share_close.0afbfbb4660b686f3e0886176cb05ed3.svg";
export { ForwardRef as ReactComponent };